import { Box, Grid, Link, Theme, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { ProviderInfo } from '../../../types/type';
import { getPrettyPhoneNumber } from '../../../utils/Utilities';
import VisitWebSite from '../VisitWebsite/VisitWebsite';

interface ProviderInfoCollectionType {
  providerInfo: ProviderInfo[];
}

const SelectedServiceInfoSummary = (props: ProviderInfoCollectionType) => {
  const theme: Theme = useTheme();
  const providerInfoRowStyle = {
    ...theme.custom.styles.primaryDescription,
    color: 'black',
  };
  const oddRowStyling = {
    backgroundColor: theme.custom.colors.listSelectionBackgroundColor,
    padding: '0.5rem 1rem 1rem 0rem',
  };
  const evenRowStyling = {
    padding: '0.5rem 1rem 1rem 0rem',
  };

  function HeaderRow() {
    return (
      <Grid container>
        <Grid item xs={3}>
          <Typography sx={theme.custom.styles.contactCardHeaderRowStyle}>{'Service'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography sx={theme.custom.styles.contactCardHeaderRowStyle}>{'Partner'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography sx={theme.custom.styles.contactCardHeaderRowStyle}>{'Website'}</Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography sx={theme.custom.styles.contactCardHeaderRowStyle}>{'Contact Methods'}</Typography>
        </Grid>
      </Grid>
    );
  }

  function ProviderRow(props: any) {
    return (
      <React.Fragment>
        <Grid item xs={3} sx={props.rowIndex % 2 !== 0 ? oddRowStyling : evenRowStyling}>
          <Typography sx={providerInfoRowStyle}>{props.provider.serviceTypeName}</Typography>
        </Grid>
        <Grid item xs={3} sx={props.rowIndex % 2 !== 0 ? oddRowStyling : evenRowStyling}>
          <Typography sx={providerInfoRowStyle}>{props.provider.providerName}</Typography>
        </Grid>
        <Grid item xs={3} sx={props.rowIndex % 2 !== 0 ? oddRowStyling : evenRowStyling}>
          {props.provider.providerUrl && <VisitWebSite websiteAddress={props.provider.providerUrl}></VisitWebSite>}
        </Grid>
        <Grid item xs={3} sx={props.rowIndex % 2 !== 0 ? oddRowStyling : evenRowStyling}>
          {props.provider.providerPhone && (
            <Typography sx={providerInfoRowStyle}>
              {'Telephone:'}
              <Link
                underline="none"
                sx={theme.custom.styles.phoneNumberAndWebSiteStyle}
                href={`tel:${getPrettyPhoneNumber(props.provider.providerPhone)}`}
              >
                {' ' + getPrettyPhoneNumber(props.provider.providerPhone) + ''}
              </Link>
            </Typography>
          )}
        </Grid>
      </React.Fragment>
    );
  }
  return (
    <Box sx={{ width: '100%' }}>
      <Grid container>
        <Grid container item>
          <HeaderRow />
        </Grid>
        <Grid container item>
          {props.providerInfo.map((provider, index) => (
            <>
              <ProviderRow key={provider.providerName} provider={provider} rowIndex={index + 1}></ProviderRow>

              <hr style={theme.custom.styles.listItemDividerHrStyle}></hr>
            </>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default SelectedServiceInfoSummary;
